var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmbedIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6872 2.97765H17.2492C18.5912 2.97765 19.5673 3.95543 19.5673 5.29987V7.86654H18.1032V5.29987C18.1032 4.81098 17.7372 4.44431 17.2492 4.44431H14.6872V2.97765ZM1.5109 7.86654V5.29987C1.5109 4.9332 1.87691 4.44431 2.36492 4.44431H4.92697V2.97765H2.36492C1.02289 2.97765 0.046875 3.95543 0.046875 5.29987V7.86654H1.5109ZM4.92697 21.0665H2.36492C2.13842 21.0665 1.9212 20.9764 1.76104 20.816C1.60088 20.6555 1.5109 20.4379 1.5109 20.211V17.6443H0.046875V20.211C0.046875 20.8221 0.29088 21.4332 0.656887 21.7999C1.1449 22.2888 1.75491 22.5332 2.36492 22.5332H4.92697V21.0665ZM18.1032 17.6443V20.211C18.1032 20.6999 17.7372 21.0665 17.2492 21.0665H14.6872V22.5332H17.2492C17.8544 22.5036 18.427 22.2494 18.8555 21.8202C19.284 21.3909 19.5377 20.8173 19.5673 20.211V17.6443H18.1032ZM13.8331 10.0665L10.5391 13.3665V0.533203H9.07505V13.3665L5.78099 10.0665L4.68297 11.1665L8.83105 15.3221C9.07505 15.5665 9.44106 15.6888 9.68506 15.6888C9.92907 15.6888 10.2951 15.5665 10.5391 15.3221L14.6872 11.1665L13.8331 10.0665Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmbedIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EmbedIcon.ecbc87e0.svg";
export { ForwardRef as ReactComponent };